var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/country', 'app-common/util/cache-manager'], function($, core, CountryCollection, cacheManager) {
  var CachedCountryCollection;
  CachedCountryCollection = (function(_super) {

    __extends(CachedCountryCollection, _super);

    function CachedCountryCollection() {
      CachedCountryCollection.__super__.constructor.apply(this, arguments);
    }

    CachedCountryCollection.prototype.initialize = function(models, options) {
      CachedCountryCollection.__super__.initialize.call(this, models, options);
      return cacheManager.wrapFetch(this, 'country');
    };

    return CachedCountryCollection;

  })(CountryCollection);
  return CachedCountryCollection;
});
